var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"buttons"},[_c('div',{staticClass:"button",on:{"click":_vm.go}},[_vm._v("已完成支付")]),_c('div',{staticClass:"button active",on:{"click":_vm.back}},[_vm._v("支付遇到问题，重新支付")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }